import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FieldRadioButton } from '../../../components';
import css from './SectionOfferingsForm.module.css';
const ShippingAddressOptionsField = () => {
  return (
    <div className={css.fieldGroup}>
      <label className={css.label}>
        <FormattedMessage id="AutographFormFields.shippingAddress" />
      </label>
      <div className={css.radioGroup}>
        <FieldRadioButton
          id="photo-address-profile"
          name="addressType"
          label={`Profile Address`}
          value="profile"
        />
        <FieldRadioButton
          id="photo-address-custom"
          name="addressType"
          label="Custom Address"
          value="custom"
        />
      </div>
    </div>
  );
};

export default ShippingAddressOptionsField;
